import { useEffect } from 'react';
import { TUTORIAL_PROJECT_TITLE, TUTORIAL_PROJECT_STORY } from '../services/TutorialMockProvider';

export function useTutorialProjectDialog({
    isActive, currentStep, nextStep,
    setTitle, setProjectType, setStory, setIsGenerating,
    onCreate, onClose, title, story
}) {
    // AutoType for Tutorial
    useEffect(() => {
        if (isActive && currentStep === 1) {
            setProjectType('idea');
            setTitle('');
            setStory('');

            const targetTitle = TUTORIAL_PROJECT_TITLE;
            const targetIdea = "On a playful hike, Max the goldendoodle sniffs out a buried wooden box containing a map and a mysterious golden coin. His owners try to solve the mystery, but Max just wants to play fetch with the coin.";

            let tIndex = 0;
            let sIndex = 0;

            const typeTitle = setInterval(() => {
                setTitle(targetTitle.substring(0, tIndex + 1));
                tIndex++;
                if (tIndex >= targetTitle.length) {
                    clearInterval(typeTitle);
                    const typeStory = setInterval(() => {
                        setStory(targetIdea.substring(0, sIndex + 1));
                        sIndex++;
                        if (sIndex >= targetIdea.length) {
                            clearInterval(typeStory);
                            setTimeout(() => nextStep(), 250);
                        }
                    }, 15);
                }
            }, 25);

            return () => {
                clearInterval(typeTitle);
            };
        }
    }, [isActive, currentStep, nextStep, setTitle, setProjectType, setStory]);

    const handleTutorialCreate = () => {
        if (isActive && currentStep === 2) {
            setIsGenerating(true);
            setTimeout(() => {
                setIsGenerating(false);
                setStory(TUTORIAL_PROJECT_STORY);
                setProjectType('story');
                nextStep();
            }, 1500);
            return true;
        }

        if (isActive && currentStep === 4) {
            onCreate({ title: title || TUTORIAL_PROJECT_TITLE, story, is_tutorial: true });
            onClose();
            nextStep();
            return true;
        }

        return false;
    };

    return { handleTutorialCreate };
}
